import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from 'src/environments/environment';
import { ColDef, GridOptions } from 'ag-grid-community';
import { LicenseManager } from 'ag-grid-enterprise';
import { ThemeService } from 'src/app/services/theme.service';
import { Subscription } from 'rxjs';
import { AgGridToolsService } from '../ag-grid-table/services/ag-grid-tools.service';
import {
  FloraColDef,
  MOBILE_BREAKPOINT_PX,
} from '../ag-grid-table/ag-grid-mobile.columns';

@Component({
  selector: 'app-ag-grid-base-table',
  templateUrl: './ag-grid-base-table.component.html',
  styleUrls: ['./ag-grid-base-table.component.sass'],
})
export class AgGridBaseTableComponent implements OnInit, OnDestroy {
  // AGGRID License manager:
  licence: any = LicenseManager.setLicenseKey(environment.agGridLicense);

  @Input() customHeight: string | null = null;
  @Input() rowData: any[] = [];
  @Input() columnDefs: ColDef[] = [];
  @Input() mobileCriticalFields?: string[];

  isMobile = false;
  displayColumnDefs: FloraColDef[] = [];
  private baseColumnDefs: FloraColDef[] = [];
  private themeSubscription: Subscription;
  private breakpointSubscription?: Subscription;

  tableHeight: string = 'auto';
  defaultColDef: ColDef = {
    filterParams: {
      suppressAndOrCondition: true,
    },
    cellClass: 'center-cell-content',
  };
  gridTheme: string;
  gridOptions: GridOptions;

  constructor(
    private themeService: ThemeService,
    private agGridToolsService: AgGridToolsService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit(): void {
    this.isMobile = window.innerWidth < MOBILE_BREAKPOINT_PX;
    this.baseColumnDefs = this.agGridToolsService.preprocessColumnDefs([
      ...this.columnDefs,
    ]) as FloraColDef[];
    this.updateColumnDefsForViewport();

    this.themeSubscription = this.themeService.isDark$.subscribe((isDark) => {
      this.toggleTheme(isDark);
    });

    this.breakpointSubscription = this.breakpointObserver
      .observe([`(max-width: ${MOBILE_BREAKPOINT_PX - 1}px)`])
      .subscribe((state) => {
        const wasMobile = this.isMobile;
        this.isMobile = state.matches;
        if (wasMobile !== this.isMobile) {
          this.updateColumnDefsForViewport();
        }
      });

    this.tableHeight =
      this.customHeight && this.customHeight !== 'null'
        ? this.customHeight
        : '70vh%';
  }

  ngOnDestroy(): void {
    this.themeSubscription?.unsubscribe();
    this.breakpointSubscription?.unsubscribe();
  }

  private updateColumnDefsForViewport(): void {
    this.displayColumnDefs = this.agGridToolsService.applyMobileColumnVisibility(
      this.baseColumnDefs,
      this.isMobile,
      this.mobileCriticalFields
        ? { mobileCriticalFields: this.mobileCriticalFields }
        : undefined,
    );
  }

  toggleTheme(isDarkMode: boolean) {
    this.gridTheme = isDarkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine';
  }

  getGridHeight() {
    if (this.customHeight) {
      return this.customHeight;
    } else {
      const height = window.innerHeight;
      if (height >= 1000) {
        return '85vh';
      } else if (height >= 900) {
        return '83vh';
      } else if (height >= 800) {
        return '78vh';
      } else if (height >= 700) {
        return '75vh';
      } else {
        return '70vh';
      }
    }
  }
}
